import "./InfoCard.css";

type InfoCardProps = {
  image: string;
  altText: string;
  imageTitle?: string;
  body: React.ReactNode;
  color?: string;
};
const InfoCard = ({
  image,
  altText,
  imageTitle,
  body,
  color,
}: InfoCardProps) => {
  return (
    <div className={`info-card-container ${color}`}>
      <div className="info-card-img-container">
        <img className="info-card-img" src={image} alt={altText} />
        {imageTitle && <h3 className="info-card-img-title">{imageTitle}</h3>}
      </div>
      {body}
    </div>
  );
};

export default InfoCard;
